<template>
  <div id="why">
    <div style="margin-bottom: 20px">
      <h3>为何参展</h3>
      <ul>
        <li>每场展会汇集了数千家顶级品牌，展商云集</li>
        <li>打造品牌活动、新增亮点活动，为企业带来商机以及机遇</li>
        <li>升级美化布展和环境布置，提升观展体验及商业氛围</li>
        <li>品牌提升，宣传品牌，宣传企业，推广公司，拓展潜在的市场</li>
      </ul>
    </div>
    <div>
      <h3>为何参观</h3>
      <ul>
        <li>新品首发、商贸首选平台</li>
        <li>了解产品行情，减少因信息原因造成的产品差价损失</li>
        <li>营造全新的生活方式，引领行业发展趋势</li>
        <li>方便试用新产品</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "why-page",
};
</script>

<style lang="scss" scoped>
#why {
  background: #fff url("../../assets/image/bg_9.png") no-repeat;
  background-size: cover;
  padding: 20px 16px;
  h3 {
    font-size: 20px;
    color: #ff5353;
    font-weight: 600;
    padding-bottom: 10px;
  }
  ul {
    padding-left: 10px;
  }
  li {
    color: #333;
    line-height: 24px;
    list-style: disc;
  }
}
</style>